module.exports = __webpack_public_path__ + "static/media/citi-logo.3dcc5c4b.png";